<template>
    <div ref="itemDnd" class="tc-case-menu-item-dnd" draggable="false" @mousemove="onMouseMoveHandler" @mousedown="onMouseDownHandler" @mouseup.prevent="onPointerUpHandler">
        <img class="tc-item-dnd-image" draggable="false"
             :src="getImage(item.image)">
        <div class="tc-item-dnd-tip-anchor">
            <div class="tc-item-dnd-tip">
                <SVGDND/>
            </div>
        </div>
        <div class="tc-item-dnd-text">
            {{ item.name }}
        </div>
    </div>
</template>

<script>
import SVGDND from '@/UI/SVG/SVGDND.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getImage } from '@/libs/getImage';
import { useStoreUI } from '@/Store/storeUI';
import { initDown } from '@/Engine/eventHandlers/onMouseDownHandler';
import { onPointerUpHandler } from '@/Engine/eventHandlers/onMouseUpHandler';
import { accessoryPrototypeIdForShields, smallCasePrototypeIds } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { $ } from '@/Engine/state';
import { isCaseWithoutSeparator, onPointerMoveHandler } from '@/Engine/eventHandlers/onPointerMoveHandler';
export default {
    name: 'CaseMenuItemDND',
    components: { SVGDND },
    setup() {
        const storeCaseConfiguration = useStoreCaseConfiguration();
        const uiStore = useStoreUI();
        return {
            storeCaseConfiguration,
            uiStore,
        };
    },
    props: [
        'item',
    ],
    methods: {
        onPointerUpHandler,
        onMouseDownHandler(event) {
          if (this.isDisable()) return;
          this.uiStore.setDndItem(this.item.id);
          initDown(event);
        },
        onMouseMoveHandler(event) {
          this.isDisable();
          onPointerMoveHandler(event);
        },
        isDisable() {
          //в отсутствии экранов аксессуары зафрижены для выбора (их не на что вешать)
          if (!$.toolChest?.shield?.length && accessoryPrototypeIdForShields.includes(this.item.id)) {
            this.$refs.itemDnd.classList.add('cursor-no-drop');
            return true;
          }
          if (!$.toolChest?.shield?.length && !$.toolChest?.shelf?.length && this.item.id.includes('plas_box')) {
            this.$refs.itemDnd.classList.add('cursor-no-drop');
            return true;
          }
          // ниши зафрижены до установки перегородки TCD-1800
          if (this.item.id === 'niches_tc_1995' && !$.toolChest?.separator?.find(x => x.prototypeId === 'tcd_1800')) {
            this.$refs.itemDnd.classList.add('cursor-no-drop');
            return true;
          }
          //в отсутствии перегородки малые комплектующи зафрижены для выбора (их не на что цеплять)
          //кроме экранов (так как они крепятся к корпусу)
          if (isCaseWithoutSeparator(this.item.id) &&
              (!$.toolChest?.separator?.length && !$.toolChest?.separatorT?.length)) {
            this.$refs.itemDnd.classList.add('cursor-no-drop');
            return true;
          }
          this.$refs.itemDnd.classList.remove('cursor-no-drop');
          return false;
        },
        getImage,
    },

};
</script>

<style scoped lang="scss">
.tc-case-menu-item-dnd {
    display: flex;
    flex-direction: column;
    height: max-content;
    gap: 10px;
    justify-content: flex-start;
    align-items: center;
    color: #333333;
    position: relative;
    user-select: none;
    transition: 0.3s ease all;
    cursor: grab;
}

.tc-case-menu-item-dnd:hover {
    color: #00458D;
}
.cursor-no-drop {
  cursor: no-drop;
}
.tc-item-dnd-image {
    width: 120px;
    height: 65px;
    object-fit: contain;

    //background-color: #D9D9D9; //    TEMP
}

.tc-item-dnd-tip-anchor {
    position: absolute;
    display: flex;
    align-items: flex-end;
    height: 0;
}


.tc-item-dnd-tip {
    position: relative;
    top: 65px;
    left: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;

}

.tc-item-dnd-text {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
    width: 120px;
    height: max-content;
}


</style>
